<template>
  <main class="main">
    <div v-if="page">
      <Breadcrumbs :items="breadcrumbs" />
      <h1 class="heading">{{ page.name }}</h1>
      <DynamicPageContent :content="perex" class="mt-3" />
      <DynamicPageContent :content="content" class="mt-5" />
      <div v-if="events.data.length">
        <h2 class="heading heading--2 heading--thin mt-5">
          {{ t('global.choose-an-event') }}
        </h2>
        <EventGrid :data="events.data" class="mt-4" hide-type />
      </div>
    </div>
  </main>
</template>

<script setup>
import { pageTransition } from '~/helpers/animations/animations';
const { locale, t } = useI18n();

definePageMeta({
  pageTransition: pageTransition,
});

const pageQuery = gql`
  query GetPageData {
    page(id: 69) {
      id
      breadcrumbs {
        name
        route_id
      }
      seo_meta_title
      seo_meta_description
      seo_meta_keywords
      name
      perex
      content
    }
    events(filterCategory: "11", types: "event") {
      data {
        id
        name
        type
        categories {
          name
        }
        slug: seo_url_slug {
          cs
          en
        }
        image: image_list {
          url
          width
          height
        }
        imageCrop: image_list_crop_to
        buildings {
          id
          name
          seo_url_slug {
            cs
            en
          }
        }
        dates {
          id
          start_at {
            timestamp
          }
          end_at {
            timestamp
          }
          image_list
          image_detail
        }
      }
    }
  }
`;
const { client } = useApolloClient();

const { data, refresh } = await useAsyncData(
  'weekend-workshops-' + locale.value,
  () =>
    client
      .query({
        query: pageQuery,
        fetchPolicy: 'no-cache',
        context: {
          headers: {
            'Content-Language': locale.value,
          },
        },
      })
      .then((res) => res.data),
  {
    watch: [locale],
  }
);

const page = computed(() => data.value?.page);
const events = computed(() => data.value?.events);
const content = computed(() => data.value?.page?.content);

const breadcrumbs = computed(() => {
  if (!data.value?.page?.breadcrumbs) return [];
  return data.value.page.breadcrumbs.map((breadcrumb) => {
    const innercrumb = {};
    if (breadcrumb.name) {
      innercrumb.title = breadcrumb.name;
    }
    if (breadcrumb.route_id !== null) {
      innercrumb.route = breadcrumb.route_id;
    }
    return innercrumb;
  });
});

const perex = computed(() => [
  {
    type: 'perex',
    data: {
      text: page.value?.perex,
    },
  },
]);

useHeadData({
  title: computed(() => page.value?.seo_meta_title || page.value?.name || null),
  description: computed(() => page.value?.seo_meta_description || null),
  keywords: computed(() => page.value?.seo_meta_keywords || null),
});
</script>
